import { render, staticRenderFns } from "./DsfrBadge.vue?vue&type=template&id=7f7ffd5e&scoped=true&"
import script from "./DsfrBadge.vue?vue&type=script&lang=js&"
export * from "./DsfrBadge.vue?vue&type=script&lang=js&"
import style0 from "./DsfrBadge.vue?vue&type=style&index=0&id=7f7ffd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ffd5e",
  null
  
)

export default component.exports